import AbstractContainer from './AbstractContainer';
import { ContainerType } from '../common/Constant';
import Filter from '../utils/Filter';

/**
 * @export
 * @class Board
 * @extends {AbstractContainer}
 */
export default class Board extends AbstractContainer {
  constructor(elId, uid, opts) {
    super(elId, uid, opts);
    this.type = ContainerType.BOARD;
  }

  setAllData(allData) {
    super.setAllData(allData);

    let data = allData;
    if (typeof allData === 'string') {
      data = JSON.parse(allData);
    }

    const filter = new Filter();
    // 筛选完的数据
    let filterData = filter.execBoard(data);
    while (filterData.length) {
      let itemData = filterData.shift();
      this.data = JSON.stringify(itemData);
    }

    this.allData = [];
  }

  set store(val) {
    super.store = val;
    let info = {};
    info.hash = '';
    info.slideIndex = 0;
    info.slidesTotal = 0;
    info.stepIndex = 0;
    info.stepsTotal = 0;
    info.originWidth = 1;
    info.originHeight = 1;
    this.store.setKV('info', info);
  }

  get store() {
    return this._store;
  }
}
